import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const {
    palette: { secondary },
    breakpoints
  } = theme;

  return {
    tabs: {
      width: "100%",
      minHeight: 42,
      "& .MuiTab-root.Mui-selected": {
        color: secondary.dark
      },
      [breakpoints.down(Breakpoints.SM_600)]: {
        width: "100%"
      }
    },
    tab: {
      height: 46,
      width: "50%",
      minHeight: 42,
      minWidth: 150,
      textTransform: "capitalize",
      [breakpoints.down(Breakpoints.SM_600)]: {
        minWidth: "50%",
        fontSize: 14
      }
    },
    activeTab: {
      backgroundColor: secondary.dark
    }
  };
});
